module.exports = __webpack_public_path__ + "img/img8.aa2f72b0.png";